// @flow

export const USERDATA_INITIAL = 'USERDATA_INITIAL';
export const USERDATA_FORM_SUBMIT = 'USERDATA_FORM_SUBMIT';
export const USERDATA_UPDATE_LOADER = 'USERDATA_UPDATE_LOADER';
export const USERDATA_RESET_LOADER = 'USERDATA_RESET_LOADER';
export const USERDATA_CHANGE = 'USERDATA_CHANGE';
export const CALCULATION_JOURNEY_STARTED = 'CALCULATION_JOURNEY_STARTED';
export const USERDATA_TOKEN_UPDATE = 'USERDATA_TOKEN_UPDATE';
export const UPDATE_INSURANCE_LIST = 'UPDATE_INSURANCE_LIST';
export const UPDATE_COVERAGE_LIST = 'UPDATE_COVERAGE_LIST';
export const UPDATE_ANCHOR_TEXT = 'UPDATE_ANCHOR_TEXT';
export const UPDATE_ANCHOR_CHECKBOX = 'UPDATE_ANCHOR_CHECKBOX';
export const UPDATE_TRANSLATION_CONFIRMATION = 'UPDATE_TRANSLATION_CONFIRMATION';